import { Component, ViewChild, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Service */
import { StateService } from '@services';
import { DevicesService } from '@services/http/devices.service';

/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';

/*Models */
import { CaptchaError, CaptchaItem, Device } from '@models';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'send-capcha-modal',
  templateUrl: './send-capcha.component.html'
})

export class SendCapchaModalComponent implements OnDestroy {

  @ViewChild('sendCapchaModal') sendCapchaModal: BsModalComponent;
  capchaCodeModel: string;
  passwordModel: string;
  currentDevice: Device;
  errorMessage: string;;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  capcha = {
    capchaId: null,
    capchaUri: null
  };
  btnText = {
    text: 'Продолжить',
    defaultText: 'Продолжить',
    loadText: 'Обработка..'
  };
  captchaError: CaptchaError;
  trySubmit = false;
  showPasswordParam =false;
  constructor(private stateService: StateService, private devicesService: DevicesService) {

    this.stateService.needSendCaptchaObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe((captchaError: CaptchaError) => {
        this.captchaError = captchaError;
        this.open();
      });

    this.stateService.currentDeviceObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(device => {
        this.currentDevice = device;
      });
  }

  open() {
    this.trySubmit = false;
    this.showPasswordParam = false
    this.capchaCodeModel = null;
    this.passwordModel = null;
    this.errorMessage = null;
    this.sendCapchaModal.open();
  }
  submit() {
    this.trySubmit = true;
    this.errorMessage = null;
    if (!this.capchaCodeModel || !this.passwordModel) {
      return false;
    }
      const body: CaptchaItem = {
        capchaId: this.captchaError.capchaId,
        capchaCode: this.capchaCodeModel
      };

    this.devicesService.updatePassword(
      this.passwordModel,
      null,
      this.currentDevice.providerAccountId,
      true,
      this.captchaError.capchaId,
     this.capchaCodeModel
    )
      .subscribe(response => {
        this.trySubmit = false;
        this.btnText.text = this.btnText.defaultText;

        this.stateService.loadState();
        this.close();
      },
        error => {

          let errorMessage = 'Ошибка, проверьте корректность данных или повторите позже';
          if (error.error) {
            error = error.error;
          }
          if (error.capchaId && error.capchaUri) {
            this.captchaError.capchaId = error.capchaId;
            this.captchaError.capchaUri = error.capchaUri;

          }
          if (error.errorMessage && error.errorMessage.length > 0) {
            errorMessage = error.errorMessage;

          } else if(error.message && error.message.length > 0){
            errorMessage = error.message;
          }
          this.errorMessage = errorMessage;
          this.trySubmit = false;
          this.btnText.text = this.btnText.defaultText;
        }
      );
  }

  close() {
    this.sendCapchaModal.close();
  }
  showPassword(){
    this.showPasswordParam = ! this.showPasswordParam;
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/view/modal/send-capcha/send-capcha.component.ts